import { GET_TOURS_START, GET_TOURS_SUCCESS, GET_TOURS_ERROR } from "Constant";

const initialState = {
  loading: false,
  getToursData: [],
  message: "",
};

export default function LIstOfFleetReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case GET_TOURS_START:
      return {
        ...state,
        loading: true,
      };
    case GET_TOURS_SUCCESS:
      return {
        ...state,
        getToursData: action.payload,
        loading: false,
      };
    case GET_TOURS_ERROR:
      return {
        ...state,
        getToursLoading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
